import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ParasutAuthCallbackPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { user, completeParasutAuth } = useAuth();

  useEffect(() => {
    let active = true;
    (async () => {
      const code = String(params.get("code") || "").trim();
      const state = String(params.get("state") || "").trim();
      if (!code || !state) {
        toast.error("Paraşüt dönüş parametreleri eksik");
        navigate("/giris", { replace: true });
        return;
      }
      try {
        if (user) {
          await api.post("/parasut/connect/exchange", { code, state });
          if (!active) return;
          toast.success("Paraşüt hesabı bağlandı!");
          navigate("/panel/hesabim/firmalarim", { replace: true });
        } else {
          const result = await completeParasutAuth(code, state);
          if (!active) return;
          toast.success("Paraşüt ile giriş başarılı!");
          navigate(result.redirectPath || "/panel", { replace: true });
        }
      } catch (e) {
        if (!active) return;
        toast.error(e?.message || "Paraşüt ile giriş başarısız");
        navigate("/giris", { replace: true });
      }
    })();
    return () => {
      active = false;
    };
  }, [completeParasutAuth, navigate, params, user]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <Loader2 className="mx-auto h-6 w-6 animate-spin text-[#1487a3]" />
        <p className="mt-3 text-sm text-muted-foreground">Paraşüt ile giriş tamamlanıyor...</p>
      </div>
    </div>
  );
}
